import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownOrganisationUsers = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, onChange, initialValue } ) =>
{
    const url = '/organisation/current/users2' ;

    const mapFn = ( record )  =>
    {
        return {
            ...record, full_name: record.firstname + ' ' + record.surname + ' ( ' + record.user_type_name + ' )'
        }
    }

    const params = {
        url: url,
        keyFieldName: 'user_id',
        labelFieldName: 'full_name',
        additionalFields: ['enc_user_id'],
        mapFn: mapFn
    }

    const [ loading, items ] = useListboxFetch( params ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} initialValue={initialValue} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownOrganisationUsers;
